module.exports = __webpack_public_path__ + "img/Analytic Reports.3718d422.svg";